var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"market-col-hd"},[_vm._v("\n  初始化账户\n  "),_c('el-tooltip',{attrs:{"content":_vm.tip,"placement":"top"}},[_c('i',{staticClass:"el-icon-question market-col-hd__icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70277ec9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/user/eval_jees/MarketColumnHeader.vue
// module id = null
// module chunks = 